import { Box } from '@chakra-ui/react';
import React from 'react';
import { RiQuestionFill } from 'react-icons/ri';

export default function LaunchdeckTourButton({handleClick}) {

  if (!handleClick) {
    return null
  } else {
    return (
      <Box as={RiQuestionFill} boxSize="1em" cursor={handleClick && "pointer"} onClick={handleClick} />
    )
  }

  
}